const PATH_PREFIX = typeof __PATH_PREFIX__ !== 'undefined' ? __PATH_PREFIX__ : ''
const asset = (path) => `${PATH_PREFIX}/bbxbratz/${path}`

export const STORAGE_KEY = "game-bratz-x-bb"
export const GAME_WIDTH = 1216
export const GAME_HEIGHT = 632

/******** ************************** ********/
/******** ****** DRESS OBJECT ****** ********/
/******** ************************** ********/
export const DRESS_TOP_NAMES = {
	topDefaultCloe: {
		handle: '',
		name: 'Top Default Cloe',
		path: 'assets/dress/top/top-default-cloe.png',
	},
	topDefaultYasmin: {
		handle: '',
		name: 'Top Default Yasmin',
		path: 'assets/dress/top/top-default-yasmin.png',
	},
	topDefaultJade: {
		handle: '',
		name: 'Top Default Jade',
		path: 'assets/dress/top/top-default-jade.png',
	},
	topDefaultSasha: {
		handle: '',
		name: 'Top Default Sasha',
		path: 'assets/dress/top/top-default-sasha.png',
	},
	topMeyganTA: {
		handle: 'meygan-top-angel',
		name: 'Meygan Top in Angel',
		path: 'assets/dress/top/meygan-top-angel.png',
	},
	topCloeTA: {
		handle: 'cloe-top-angel',
		name: 'Cloe Top in Angel',
		path: 'assets/dress/top/cloe-top-angel.png',
	},
	topHollyTBB: {
		handle: 'holly-top-bunny-boo',
		name: 'Holly Tankini in Bunny Boo',
		path: 'assets/dress/top/holly-tankini-bunny-boo.png',
	},
	topQuinnTBB: {
		handle: 'quinn-top-bunny-boo',
		name: 'Quinn Top in Bunny Boo',
		path: 'assets/dress/top/quinn-top-bunny-boo.png',
	},
	topKianaTBB: {
		handle: 'kiana-top-bunny-boo',
		name: 'Kiana Top in Bunny Boo',
		path: 'assets/dress/top/kiana-top-bunny-boo.png',
	},
	topSimoneTKT: {
		handle: 'simone-top-kool-kat',
		name: 'Simone Top in Kool Kat',
		path: 'assets/dress/top/simone-top-kool-kat.png',
	},
	topFeliciaTKT: {
		handle: 'felicia-top-kool-kat',
		name: 'Felicia Top in Kool Kat',
		path: 'assets/dress/top/felicia-top-kool-kat.png',
	},
	topBillieTB: {
		handle: 'billie-top-bratitude',
		name: 'Billie Top in Bratitude',
		path: 'assets/dress/top/billie-top-bratitude.png',
	},
	topSydTB: {
		handle: 'syd-top-bratitude',
		name: 'Syd Top in Bratitude',
		path: 'assets/dress/top/syd-top-bratitude.png',
	},
	topYasminTPP: {
		handle: 'yasmin-top-pretty-princess',
		name: 'Yasmin Top in Pretty Princess',
		path: 'assets/dress/top/yasmin-top-pretty-princess.png',
	},
	topJasmineTPP: {
		handle: 'jasmine-top-pretty-princess',
		name: 'Jasmine Top in Pretty Princess',
		path: 'assets/dress/top/jasmine-top-pretty-princess.png',
	},
	topAddisonTNO: {
		handle: 'addison-top-night-out',
		name: 'Addison Top in Night Out',
		path: 'assets/dress/top/addison-top-night-out.png',
	},
}

export const DRESS_BOTTOM_NAMES = {
	bottomsDefaultCloe: {
		handle: '',
		name: 'Bottoms Default Cloe',
		path: 'assets/dress/bottoms/bottoms-default-cloe.png',
	},
	bottomsDefaultYasmin: {
		handle: '',
		name: 'Bottoms Default Cloe',
		path: 'assets/dress/bottoms/bottoms-default-yasmin.png',
	},
	bottomsDefaultJade: {
		handle: '',
		name: 'Bottoms Default Cloe',
		path: 'assets/dress/bottoms/bottoms-default-jade.png',
	},
	bottomsDefaultSasha: {
		handle: '',
		name: 'Bottoms Default Cloe',
		path: 'assets/dress/bottoms/bottoms-default-sasha.png',
	},
	bottomsSugarSA: {
		handle: 'sugar-skort-angel',
		name: 'Sugar Skort in Angel',
		path: 'assets/dress/bottoms/sugar-skort-angel.png',
	},
	bottomsCloeBA: {
		handle: 'cloe-bottoms-angel',
		name: 'Cloe Bottoms in Angel',
		path: 'assets/dress/bottoms/cloe-bottoms-angel.png',
	},
	bottomsMeyganBA: {
		handle: 'meygan-bottoms-angel',
		name: 'Meygan Bottoms in Angel',
		path: 'assets/dress/bottoms/meygan-bottoms-angel.png',
	},
	bottomsQuinnBBB: {
		handle: 'quinn-bottoms-bunny-boo',
		name: 'Quinn Bottoms in Bunny Boo',
		path: 'assets/dress/bottoms/quinn-bottoms-bunny-boo.png',
	},
	bottomsCameronSBB: {
		handle: 'cameron-swim-shorts-bunny-boo',
		name: 'Cameron Shorts in Bunny Boo',
		path: 'assets/dress/bottoms/cameron-shorts-bunny-boo.png',
	},
	bottomsKianaBBB: {
		handle: 'kiana-bottoms-bunny-boo',
		name: 'Kiana Bottoms in Bunny Boo',
		path: 'assets/dress/bottoms/kiana-bottoms-bunny-boo.png',
	},
	bottomsMauiBKK: {
		handle: 'maui-bottoms-kool-kat',
		name: 'Maui Bottoms in Kool Kat',
		path: 'assets/dress/bottoms/maui-bottoms-kool-kat.png',
	},
	bottomsGBKK: {
		handle: 'gemini-bottoms-kool-kat',
		name: 'Gemini Bottoms in Kool Kat',
		path: 'assets/dress/bottoms/gemini-bottoms-kool-kat.png',
	},
	bottomsKrystaBB: {
		handle: 'krysta-bottoms-bratitude',
		name: 'Krysta Bottoms in Bratitude',
		path: 'assets/dress/bottoms/krysta-bottoms-bratitude.png',
	},
	bottomsVeraBB: {
		handle: 'vera-bottoms-bratitude',
		name: 'Vera Bottoms in Bratitude',
		path: 'assets/dress/bottoms/vera-bottoms-bratitude.png',
	},
	bottomsJasmineBPP: {
		handle: 'riri-bottoms-pretty-princess',
		name: 'Jasmine Bottoms in Pretty Princess',
		path: 'assets/dress/bottoms/jasmine-bottoms-pretty-princess.png',
	},
	bottomsYasminBPP: {
		handle: 'yasmin-bottoms-pretty-princess',
		name: 'Yasmin Bottoms in Pretty Princess',
		path: 'assets/dress/bottoms/yasmin-bottoms-pretty-princess.png',
	},
	bottomsAddisionBNO: {
		handle: 'addison-bottoms-night-out',
		name: 'Addison Bottoms in Night Out',
		path: 'assets/dress/bottoms/addison-bottoms-night-out.png',
	},
}

export const DRESS_ONE_PIECE_NAMES = {
	topRoxxiOPA: {
		handle: 'roxxi-one-piece-angel',
		name: 'Roxxi One Piece in Angel',
		path: 'assets/dress/onepiece/roxxi-one-piece-angel.png',
	},
}
/******** ************************ ********/
/******** ************************ ********/

/******** ************************ ********/
/******** ASSET BUNDLES TO PRELOAD ********/
/******** ************************ ********/
export const BUNDLE_UI = {
	accessorize: asset('assets/ui/accessorize.png'),
	bratzTitle: asset('assets/ui/bratz-title.png'),
	maddys: asset('assets/ui/maddys-dress-up-dream.png'),
	dressUpDream: asset('assets/ui/dress-up-dream.png'),
	pinup: asset('assets/ui/pin-up.png'),
	sliderBg: asset('assets/ui/slider-bg.png'),
	dollStand: asset('assets/ui/doll-stand.png'),
	polaroid1: asset('assets/ui/polaroid-1.png'),
	polaroid2: asset('assets/ui/polaroid-2.png'),
	polaroid3: asset('assets/ui/polaroid-3.png'),
	polaroid4: asset('assets/ui/polaroid-4.png'),
	polaroid5: asset('assets/ui/polaroid-5.png'),
	polaroid6: asset('assets/ui/polaroid-6.png'),
	polaroidBg1: asset('assets/ui/polaroid-1-bg.png'),
	polaroidBg2: asset('assets/ui/polaroid-2-bg.png'),
	polaroidBg3: asset('assets/ui/polaroid-3-bg.png'),
	polaroidBg4: asset('assets/ui/polaroid-4-bg.png'),
	polaroidBg5: asset('assets/ui/polaroid-5-bg.png'),
	polaroidBg6: asset('assets/ui/polaroid-6-bg.png'),
	dlPolaroid1: asset('assets/ui/downloadable-polaroid-1.png'),
	dlPolaroid2: asset('assets/ui/downloadable-polaroid-2.png'),
	dlPolaroid3: asset('assets/ui/downloadable-polaroid-3.png'),
	dlPolaroid4: asset('assets/ui/downloadable-polaroid-4.png'),
	dlPolaroid5: asset('assets/ui/downloadable-polaroid-5.png'),
	dlPolaroid6: asset('assets/ui/downloadable-polaroid-6.png'),
	polaroidBackdrop: asset('assets/ui/polaroid-backdrop.png'),
}

export const BUNDLE_ICONS = {
	iconLeftCirclePurple: asset('assets/icons/left-circle-purple.png'),
	iconRightCirclePurple: asset('assets/icons/right-circle-purple.png'),
	iconLeftCirclePink: asset('assets/icons/left-circle-pink.png'),
	iconLeftCircle: asset('assets/icons/left-circle.png'),
	iconRightCircle: asset('assets/icons/right-circle.png'),
	iconDollHover: asset('assets/icons/doll-hover.png'),
	iconBag: asset('assets/icons/bag.png'),
	iconBagPurple: asset('assets/icons/bag-purple.png'),
	iconFrame: asset('assets/icons/frame.png'),
	iconFrameWhite: asset('assets/icons/frame-white.png'),
	iconFramePink: asset('assets/icons/frame-pink.png'),
	iconCaretDown: asset('assets/icons/caret-down.png'),
	iconDownload: asset('assets/icons/icon-dl.png'), 
	iconCopy: asset('assets/icons/copy.png'), 
	iconLeftCircleCaret: asset('assets/icons/left-circle-caret.png'),
	iconRightCircleCaret: asset('assets/icons/right-circle-caret.png'),
	iconPin: asset('assets/icons/purple-pin.png'),
	iconPlus: asset('assets/icons/icon-plus.png'),
	iconMinus: asset('assets/icons/icon-minus.png'),
	iconFbWhite: asset('assets/icons/icon-fb-white.png'),
}

export const BUNDLE_BUTTONS = {
	btnReset: asset('assets/buttons/btn-reset.png'),
	btnPolaroid1: asset('assets/buttons/btn-polaroid-1.png'),
	btnPolaroid2: asset('assets/buttons/btn-polaroid-2.png'),
	btnPolaroid3: asset('assets/buttons/btn-polaroid-3.png'),
	btnPolaroid4: asset('assets/buttons/btn-polaroid-4.png'),
	btnPolaroid5: asset('assets/buttons/btn-polaroid-5.png'),
	btnPolaroid6: asset('assets/buttons/btn-polaroid-6.png'),
	btnViewSizeChart: asset('assets/buttons/view-size-chart.png'),
	// btnSocialFB: asset('assets/buttons/btn-fb.png'),
	// btnSocialInstagram: asset('assets/buttons/btn-instagram.png'),
	// btnSocialTiktok: asset('assets/buttons/btn-tiktok.png'),
	// btnSocialPinterest: asset('assets/buttons/btn-pinterest.png'),
}

export const BUNDLE_DOLLS = {
	dollCloe: asset('assets/dolls/cloe.png'),
	dollYasmin: asset('assets/dolls/yasmin.png'),
	dollJade: asset('assets/dolls/jade.png'),
	dollSasha: asset('assets/dolls/sasha.png'),
}

export const BUNDLE_TOPS = Object.fromEntries(
  Object.entries(DRESS_TOP_NAMES).map(([key, value]) => [key, asset(value.path)])
)

export const BUNDLE_BOTTOMS = Object.fromEntries(
  Object.entries(DRESS_BOTTOM_NAMES).map(([key, value]) => [key, asset(value.path)])
)

export const BUNDLE_ONE_PIECE = Object.fromEntries(
  Object.entries(DRESS_ONE_PIECE_NAMES).map(([key, value]) => [key, asset(value.path)])
)

export const BUNDLE_ACCESSORIES = {
	accPouch: asset('assets/dress/extras/pouch.png'),
	accShades: asset('assets/dress/extras/shades.png'),
	accSandals: asset('assets/dress/extras/sandals.png'),
	accTowel: asset('assets/dress/extras/towel.png'),
}

export const BUNDLE_SFX = {
	sfxSelect: asset('assets/sfx/sfx-select.mp3'),
	sfxNext: asset('assets/sfx/sfx-next.mp3'),
	sfxBack: asset('assets/sfx/sfx-back.mp3'),
}

/******** ************************ ********/
/******** ************************ ********/
